import { render } from "./whatsApp.vue?vue&type=template&id=a55169c2"
import script from "./whatsApp.vue?vue&type=script&lang=js"
export * from "./whatsApp.vue?vue&type=script&lang=js"

import "./whatsApp.vue?vue&type=style&index=0&id=a55169c2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__